import { createReduxAsyncThunk } from 'shared/utils';

import { carsAPI } from '../../api';

import { CARS_STATE } from '../../constants';

import { CarLocationHistorySharing, CarsLocationSharing } from '../../types';

export const getCarLocationHistorySharing = createReduxAsyncThunk<CarLocationHistorySharing, CarsLocationSharing['id']>(
  `${CARS_STATE}/getCarLocationHistorySharing`,
  async (id) => {
    const { data } = await carsAPI.getCarLocationHistorySharing(id);
    return data;
  }
);
